import * as Yup from 'yup';
import { DateUtil, FormValidationUtil } from '../../../../../utils';

export const plannedEventIninitialValues = {
  subject: '',
  startDate: '',
  endDate: '',
  startTime: '',
  endTime: '',
  customer: '',
  comments: '',
  allDay: false,
};

export const plannedEventValidationSchema = Yup.object().shape({
  subject: Yup.string().required('Subject is required'),
  startDate: Yup.string().required('Start date is required'),
  endDate: Yup.string()
    .required('To date is required')
    .test(
      'is-after-start',
      'End Date cannot be earlier than Start Date',
      function endDateString(value) {
        const { startDate } = this.parent;
        return (
          !startDate || !endDateString || new Date(value) >= new Date(startDate)
        );
      },
    ),
  startTime: Yup.string()
    .required('From time is required')
    .test(
      'is-before-end',
      'Start Time cannot be later than End Time',
      FormValidationUtil.fromTimeBeforeToTime('endTime'),
    ),
  endTime: Yup.string()
    .required('To time is required')
    .test(
      'is-after-start',
      'End Time cannot be earlier than Start Time',
      FormValidationUtil.toTimeAfterFromTime('startTime'),
    ),
  customer: Yup.string(),
  comments: Yup.string(),
});

export const populateFormData = eventInData => {
  const formEditData = {
    subject: eventInData?.Subject,
    startDate: eventInData?.StartDate
      ? DateUtil.formatDateTimeToHtmlDate(eventInData.StartDate)
      : '',
    endDate: eventInData?.EndDate
      ? DateUtil.formatDateTimeToHtmlDate(eventInData.EndDate)
      : '',
    startTime: eventInData?.StartTime
      ? DateUtil.formatDateTimetoHtmlTime(eventInData.StartTime)
      : '',
    endTime: eventInData?.EndTime
      ? DateUtil.formatDateTimetoHtmlTime(eventInData.EndTime)
      : '',
    comments: eventInData?.Comments || '',
    customer: eventInData?.Customer || '',
    allDay: eventInData?.AllDay,
  };
  return formEditData;
};
